import React from 'react';
import './Footer.css';
import Github from '../../assets/github.png';
import Instagram from '../../assets/instagram.png';
import Linkedin from '../../assets/linkedin.png';
import Logo from '../../assets/logo.png';

const Footer = () => {
  return (
    <footer className='footer-container'>
        <div className="blur blur-f"></div>
        <div className='blur-f-r'></div>
        <hr />
        <div className="footer">
            <div className='social-links'>
                <img src={Github} alt="" />
                <img src={Instagram} alt="" />
                <img src={Linkedin} alt="" />
            </div>
            <div className="logo-f">
                <img src={Logo} alt="" />
            </div>
        </div>
    </footer>
  )
}

export default Footer